import './OpTextbox.scss'

import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'react-bootstrap'
import cx from 'classnames'

const OpTextbox = props => {
  const {
    label, required, className, id, iconClass, dataTip, onKeyDown,
    value, onChange, errorMsg, placeholder, onBlur, disabled, type, dataTestId
  } = props

  const empty = !(value && value.length)

  const inputClasses = cx(
      'form-control',
      'OpTextboxInput__input',
      {
        'OpTextboxInput__incorrect-input': !!errorMsg,
        'OpTextboxInput--with-icon': !!iconClass,
      }
    )

    const iconWrapperClass = cx(
      '',
      {
        'OpTextboxInput__icon-anchor': !!iconClass,
        'empty': iconClass && empty
      }
    )

    const labelClass = cx(
      '',
      {'error': !!errorMsg}
    )

  const fieldsetClassName = className ? `OpTextbox ${className}` : 'OpTextbox'

  return (
    <fieldset className={fieldsetClassName} id={id} data-testid={dataTestId || label}>
      {label && <label data-tip={dataTip} className={labelClass}><span className={dataTip && "OpTextbox__underline"}>{label}</span>{required && ' *'}</label>}
      <div className="OpTextboxInput form-group">
        <div className={iconWrapperClass}>
        { iconClass && <i className={iconClass}/>}
          <Input
            type={type || "text"}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            className={inputClasses}
            disabled={disabled}
          >
          </Input>
        </div>
        <div className="OpTextboxInput__error">
          {errorMsg ? (<span className="OpTextboxInput__error--message">{errorMsg}</span>) : null}
        </div>
      </div>
    </fieldset>
  )
}

OpTextbox.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconClass: PropTypes.string,
  dataTip: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,  // if you try to use this as an un-controlled input the icon styling won't work correctly
  errorMsg: PropTypes.string,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
}

export default OpTextbox
